import { render } from "./SectionContent.vue?vue&type=template&id=348fde00"
import script from "./SectionContent.vue?vue&type=script&lang=js"
export * from "./SectionContent.vue?vue&type=script&lang=js"

import "./SectionContent.vue?vue&type=style&index=0&id=348fde00&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__